export enum MarkerTypeColor {
  BLUE = 'blue',
  GREEN = 'green',
  NEW_GREEN = 'new-green',
  PURPLE = 'purple',
  NEW_PURPLE = 'new-purple',
  YELLOW = 'yellow',
  GRAY = 'gray',
  BLACK = 'black',
  BROWN = 'brown',
  ORANGE = 'orange',
  RED = 'red',
  WHITE = 'white',
}
